import React, { ReactNode, useEffect, useState } from 'react';
import { Button } from '../../components/form/button';
import { TaxJurisdictionModal } from './tax-jurisdiction-modal';
import { Card } from '../../components/card/card';
import { TabNav } from '../../components/tab-nav/tab-nav';
import { GeneralLedgerAccount } from '../../clients/quipli-service/accounting/accounting';
import { useAccountingApiV1 } from '../../clients/quipli-service/accounting/accounting-api-v1';
import Icon from '../../components/icons/icon';
import { TaxJurisdiction } from '../../clients/quipli-service/tax/tax';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';

export const TaxJurisdictionSetup = () => {
  const [tab, setTab] = useState<string>('Tax Codes');

  function getTabContent(tab: string): ReactNode {
    setTab(tab);
    switch (tab) {
      case 'Manual Tax Jurisdictions':
        return <TaxJurisdictions source={'manual'} />;
      case 'TaxJar Jurisdictions':
        return <TaxJurisdictions source={'TaxJar'} />;
      default:
        return null;
    }
  }

  useEffect(() => {
    getTabContent(tab);
  }, [tab]);

  return (
    <div className="tax-setup">
      <Card>
        <TabNav tabNames={['Manual Tax Jurisdictions', 'TaxJar Jurisdictions']} onSelect={getTabContent} />
      </Card>
    </div>
  );
};

export const TaxJurisdictions = ({ source }: { source: 'manual' | 'TaxJar' }) => {
  const [setupModalOpen, setSetupModalOpen] = useState<boolean>(false);
  const { searchTaxJurisdictions } = useTaxApiV1();
  const { listAccounts } = useAccountingApiV1();
  const [taxJurisdictions, setTaxJurisdictions] = useState<TaxJurisdiction[]>([]);
  const [glAccounts, setGlAccounts] = useState<GeneralLedgerAccount[]>([]);
  const [jurisdictionToEdit, setJurisdictionToEdit] = useState<TaxJurisdiction | undefined>();

  async function init() {
    const taxJurisdictionResult = await searchTaxJurisdictions({ source });
    setTaxJurisdictions(taxJurisdictionResult);
    setGlAccounts(await listAccounts());
  }

  useEffect(() => {
    init();
  }, [source]);
  return (
    <div className="tax-jurisdiction-setup">
      {source == 'manual' && (
        <div className="pt-6">
          <Button className="button-yellow" onClick={() => setSetupModalOpen(true)}>
            Create a tax jurisdiction
          </Button>
        </div>
      )}
      <div className={'tax-code-table py-2 pt-8 pb-8'}>
        <Card>
          <table className="w-full border-none">
            <thead>
              <tr>
                <th className={'text-left'}>
                  <span>Name</span>
                </th>
                <th className={'text-left'}>General Ledger Account</th>
                <th className={'text-right'}>
                  <span>Percentage</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {taxJurisdictions.map((jurisdiction) => {
                return (
                  <React.Fragment key={jurisdiction.name}>
                    <tr>
                      <td className={'text-left flex gap-2 items-center mt-2.5'}>
                        <div className={'flex flex-wrap gap-2 items-center tax-name group h-16'}>
                          <span>{jurisdiction.name}</span>
                          <div className="flex gap-1 jurisdiction-actions hidden group-hover:block self-center max-w-fit w-1">
                            <Button
                              className="button-tertiary jurisdiction-button"
                              onClick={() => {
                                setJurisdictionToEdit(jurisdiction);
                                setSetupModalOpen(true);
                              }}
                            >
                              <Icon icon={'Edit'} stroke="var(--grey-400)" />
                            </Button>
                            {/*<Button className="button-tertiary account-button" onClick={onDelete}>
                              <Icon icon={'Trash'} stroke="var(--grey-400)" />
                            </Button>*/}
                          </div>
                        </div>
                      </td>
                      <td className={'text-left'}>
                        <div className={'flex gap-2 items-center tax-gl group'}>
                          <span>
                            {
                              glAccounts.find((g) => {
                                return g.id == jurisdiction.generalLedgerAccountId;
                              })?.name
                            }
                          </span>
                        </div>
                      </td>
                      <td className={'text-right'}>{jurisdiction.percentage}%</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Card>
      </div>
      <TaxJurisdictionModal
        isOpen={setupModalOpen}
        jurisdiction={jurisdictionToEdit}
        close={() => {
          setSetupModalOpen(false);
          setJurisdictionToEdit(undefined);
          init();
        }}
      />
    </div>
  );
};
